import { render } from "./CompProduto.vue?vue&type=template&id=31ef8f7d&scoped=true"
import script from "./CompProduto.vue?vue&type=script&lang=js"
export * from "./CompProduto.vue?vue&type=script&lang=js"

import "./CompProduto.vue?vue&type=style&index=0&id=31ef8f7d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ef8f7d"]])

export default __exports__